import CityPage from "@/components/feature/CityPage";

const data = {
  cityName: "Owatonna",
  stateName: "Minnesota",
  stateAbbr: "MN",
  stateRoute: "/minnesota",
  heroImageQuery:
    "Aerial view of Owatonna Minnesota southern Minnesota city in Steele County, historic downtown with Central Park and the famous National Farmers' Bank building by Louis Sullivan, residential neighborhoods with Victorian and modern homes, Medford Outlet area commercial district, Interstate 35 visible on the edge of town, flat agricultural landscape surrounding the city, daytime photography with clear sky, professional aerial photography, no readable signs or text",
  heroImageSeq: "owatonna-mn-hero-2026",
  heroDescription:
    "Business trip to Europe with three weeks notice? Family cruise to Mexico with six weeks to spare? Summer heritage trip to Norway or Germany? We help Owatonna residents — from Wenger Manufacturing and Federated Insurance professionals to Steele County families and southern Minnesota's agricultural community — get their passports fast. As a registered U.S. Department of State courier, we offer a best price guarantee and rates 30–100% lower than FedEx, Staples, and other resellers. As fast as 24 hours. A+ BBB rated.",
  geoPosition: "44.0839; -93.2260",
  geoPlacename: "Owatonna, Minnesota",
  geoRegion: "US-MN",
  canonicalUrl: "https://fastpassportcenter.com/owatonna/",
  localAreaTitle: "Serving Owatonna & South Central Minnesota",
  localAreaText: [
    "Owatonna, Minnesota is the county seat of Steele County and a major economic hub in south central Minnesota, located along the I-35 corridor between the Twin Cities and Mason City, Iowa. The city is nationally recognized for its historic architecture, including the National Farmers' Bank designed by Louis Sullivan — one of the most famous small-town banks in America — and the historic downtown district.",
    "The city's economy is anchored by major employers including Wenger Manufacturing (a leading food processing equipment manufacturer), Federated Insurance, and the Viracon glass manufacturing plant. The Steele County Fairgrounds and the Village of Yesteryear preserve the area's agricultural heritage. Owatonna's industrial base creates a professional community with regular international travel needs.",
    "Owatonna's location on I-35 provides direct north-south access to the Twin Cities, Mankato, and Albert Lea. The city is a regional shopping and medical hub for southern Minnesota, drawing residents from surrounding Steele, Waseca, Freeborn, and Rice counties. The Steele County History Center and the Minnesota State Public School Orphanage Museum preserve the area's unique history.",
    "The surrounding agricultural landscape — productive farmland and rural communities — creates a strong connection to rural Minnesota. Many Owatonna families trace their roots to Scandinavian and German immigrants, maintaining cultural connections through heritage travel, community organizations, and church groups. The city's Main Street and downtown events maintain a strong community identity.",
  ],
  nearbyCities: [
    { name: "Owatonna", zips: "55060" },
    { name: "Faribault", zips: "55021" },
    { name: "Waseca", zips: "56093" },
    { name: "Albert Lea", zips: "56007" },
    { name: "Northfield", zips: "55057" },
    { name: "Mankato", zips: "56001" },
  ],
  benefits: [
    {
      icon: "ri-computer-line",
      title: "Start 100% Online",
      desc: "No office visit required. Complete your order from your Owatonna home in minutes.",
    },
    {
      icon: "ri-truck-line",
      title: "Ship Your Documents",
      desc: "Overnight shipping from any UPS or FedEx location in the Owatonna area.",
    },
    {
      icon: "ri-shield-check-line",
      title: "Expert Document Review",
      desc: "Every application reviewed before submission to catch errors that cause delays.",
    },
    {
      icon: "ri-calendar-check-line",
      title: "Reserved Agency Access",
      desc: "Reserved submission slots at the regional passport agency — no public appointment needed.",
    },
  ],
  serviceAreaTitle: "Owatonna & South Central Minnesota",
  serviceAreaDescription: "Serving Steele County and south central Minnesota communities with overnight courier",
  faqs: [
    {
      q: "How fast can I get a passport in Owatonna, MN?",
      a: "Through Fast Passport Center, expedited processing can be as fast as 24 hours depending on your eligibility. Standard government processing through an Owatonna area post office can take 2–6 months — not suitable for upcoming trips.",
    },
    {
      q: "Can Owatonna residents get passports before a business trip to Europe or Asia?",
      a: "Absolutely. Owatonna professionals from Wenger Manufacturing, Federated Insurance, and area manufacturers regularly travel internationally. We process expedited renewals and new applications with compressed timelines — as fast as 2–9 business days.",
    },
    {
      q: "Do I need to visit an office to use Fast Passport Center from Owatonna?",
      a: "No — most Owatonna travelers start online and ship their documents via overnight courier. There is no local Fast Passport Center office in Owatonna. You can ship from FedEx or UPS locations nearby in Owatonna or Faribault.",
    },
    {
      q: "My family is planning a summer trip to Norway. How early should we start passport renewals?",
      a: "We recommend starting at least 8 weeks before departure for standard expedited processing. If you are within 3 weeks of departure, you likely need our faster 2–9 business day option. Start as soon as you confirm travel plans.",
    },
    {
      q: "What if I need a passport for a last-minute business conference?",
      a: "Corporate travelers from Owatonna can use our emergency 24-hour service if they have proof of imminent travel. We process urgent renewals for manufacturing and insurance professionals regularly.",
    },
    {
      q: "Are there passport acceptance facilities near Owatonna?",
      a: "The Owatonna Post Office, Faribault Post Office, and Waseca Post Office all accept passport applications. We can guide you to the best option based on your schedule and situation.",
    },
  ],
  testimonials: [
    {
      name: "Robert H.",
      location: "Owatonna, MN",
      rating: 5,
      text: "I work in manufacturing and received a conference assignment to Germany with three weeks notice. My passport had expired. Fast Passport Center processed my renewal in four business days. The team was professional and kept me informed. I made my conference and it was a great success.",
      service: "Passport Renewal",
    },
    {
      name: "The Johnson Family",
      location: "Owatonna, MN",
      rating: 5,
      text: "We planned a Scandinavian heritage trip to Norway and Sweden for our family reunion. We had six weeks. Fast Passport Center processed all four family passports in seven business days. The checklist was incredibly helpful and we had a wonderful trip visiting our ancestral villages.",
      service: "Family Renewal",
    },
    {
      name: "Sarah K.",
      location: "Owatonna, MN",
      rating: 5,
      text: "I needed to visit family in Germany for an emergency situation with two weeks notice. My passport was expired. Fast Passport Center processed my renewal in four business days. The emergency service was exactly what I needed. I was able to be with my family when they needed me.",
      service: "Emergency Passport",
    },
  ],
  nearbyLinks: [
    { name: "Faribault", href: "/faribault" },
    { name: "Northfield", href: "/northfield" },
    { name: "Mankato", href: "/mankato" },
    { name: "Minneapolis", href: "/minneapolis" },
    { name: "Rochester", href: "/rochester-mn" },
    { name: "Austin", href: "/austin-mn" },
  ],
  introTitle: "Emergency & Expedited Passport Services in Owatonna",
  introDescription: "Fast passport processing for Owatonna and south central Minnesota travelers.",
  localResourcesIntro:
    "Getting your passport ready involves more than just the application. Here are local Owatonna and south central Minnesota resources to help you gather everything you need before your next international trip.",
  acceptanceFacilities: [
    {
      name: "Owatonna Post Office",
      address: "300 W Broadway St, Owatonna, MN 55060",
      hours: "Mon–Fri 9:00 AM – 4:00 PM (appointment required)",
      phone: "(507) 451-3730",
      notes: "Primary passport acceptance facility for Owatonna and Steele County residents. Appointment required. Call ahead for photo availability.",
    },
    {
      name: "Faribault Post Office",
      address: "30 3rd St NW, Faribault, MN 55021",
      hours: "Mon–Fri 9:00 AM – 4:00 PM",
      phone: "(507) 334-4311",
      notes: "Rice County seat. Full passport services. Good alternative for north Owatonna residents.",
    },
    {
      name: "Waseca Post Office",
      address: "119 State St N, Waseca, MN 56093",
      hours: "Mon–Fri 9:00 AM – 4:00 PM",
      phone: "(507) 835-4511",
      notes: "Waseca County. Full passport services. Convenient for west Owatonna residents.",
    },
    {
      name: "Albert Lea Post Office",
      address: "141 S Newton Ave, Albert Lea, MN 56007",
      hours: "Mon–Fri 9:00 AM – 4:00 PM",
      phone: "(507) 373-2361",
      notes: "Freeborn County. Full passport services. Convenient for south Owatonna residents.",
    },
  ],
  photoLocations: [
    { name: "Walgreens — Owatonna", address: "1030 W Bridge St, Owatonna, MN 55060", hours: "Call for hours" },
    { name: "CVS Pharmacy — Owatonna", address: "1400 W Frontage Rd, Owatonna, MN 55060", hours: "Daily 7 AM – 10 PM" },
    { name: "Walgreens — Faribault", address: "200 Western Ave, Faribault, MN 55021", hours: "Call for hours" },
    { name: "CVS Pharmacy — Faribault", address: "700 4th St NW, Faribault, MN 55021", hours: "Daily 7 AM – 10 PM" },
    { name: "FedEx Office — Owatonna", address: "Owatonna commercial area", hours: "Call for hours" },
    { name: "The UPS Store — Owatonna", address: "Owatonna commercial area", hours: "Call for hours" },
  ],
  dmvLocations: [
    {
      name: "Steele County DVS Office",
      address: "630 Florence Ave, Owatonna, MN 55060",
      hours: "Mon–Fri, 8:00 AM – 4:30 PM",
      note: "Steele County Driver and Vehicle Services. Driver licenses, REAL ID, and passport-related ID verification.",
      featured: true,
    },
    {
      name: "Rice County DVS — Faribault",
      address: "320 NW 3rd St, Faribault, MN 55021",
      hours: "Mon–Fri, 8:00 AM – 4:30 PM",
      note: "Rice County DVS. Full driver and vehicle services.",
      featured: false,
    },
  ],
  airports: [
    {
      code: "MSP",
      name: "Minneapolis-Saint Paul International Airport",
      distance: "About 65 miles from Owatonna — 65–70 minutes by car",
      address: "4300 Glumack Drive, St. Paul, MN 55111",
      note: "Primary airport for Owatonna residents. Full international flight service. Access via I-35.",
      flightUrl: "https://www.mspairport.com/",
      flightLabel: "MSP Airport Website",
      featured: true,
    },
    {
      code: "RST",
      name: "Rochester International Airport",
      distance: "About 45 miles from Owatonna — 45–50 minutes by car",
      address: "7600 Helgerson Dr SW, Rochester, MN 55902",
      note: "Regional airport for Owatonna residents. Direct flights to major hubs. International connections available.",
      flightUrl: "https://www.flyrst.com/",
      flightLabel: "RST Airport Website",
      featured: false,
    },
  ],
  travelCards: [
    {
      title: "Wenger & Manufacturing Business Travel",
      subtitle: "Corporate professionals with international client and conference travel",
      content:
        "Owatonna is home to Wenger Manufacturing, a global leader in food processing equipment, and other major manufacturers. Area professionals regularly travel internationally for client meetings, trade shows, equipment installations, and training. These assignments are often confirmed with 2–4 weeks notice.",
      tip: "Owatonna professionals should maintain current passport validity. International client visits are frequently confirmed on short notice.",
      icon: "ri-briefcase-4-line",
    },
    {
      title: "Steele County Family Travel",
      subtitle: "Southern Minnesota families planning international vacations and heritage trips",
      content:
        "Owatonna and Steele County families plan international vacations regularly — Scandinavian heritage trips, European cultural tours, Caribbean cruises, and Mexico resort vacations. The agricultural community maintains strong family ties, and international travel is often planned around harvest seasons and school breaks.",
      tip: "Check every family member's passport at least 8 weeks before any international trip. Children's passports expire in 5 years.",
      icon: "ri-parent-line",
    },
    {
      title: "Scandinavian & German Heritage Travel",
      subtitle: "Heritage trips for Owatonna's long-established European communities",
      content:
        "Owatonna has strong Scandinavian and German heritage communities, with many families tracing their roots to Norway, Sweden, and Germany. Heritage trips to Europe are popular among multi-generational families, church groups, and community organizations.",
      tip: "European heritage trips are often planned 6+ months in advance. Start passport renewals early to avoid last-minute stress.",
      icon: "ri-earth-line",
    },
    {
      title: "Federated Insurance & Professional Services",
      subtitle: "Insurance and professional services workers with international travel",
      content:
        "Federated Insurance, headquartered in Owatonna, employs professionals who regularly travel for industry conferences, client meetings, and training events. These trips are often confirmed with 2–4 weeks notice and require current passports.",
      tip: "Insurance professionals should maintain passport validity at all times. Industry conferences are often confirmed on short notice.",
      icon: "ri-shield-check-line",
    },
  ],
  destinations: [
    {
      name: "Germany",
      context: "Business travel for Wenger Manufacturing and heritage trips for German families",
      urgency: "Business meetings and conferences have fixed schedules",
      icon: "ri-map-pin-2-line",
    },
    {
      name: "Norway & Sweden",
      context: "Heritage travel for Owatonna's Scandinavian community",
      urgency: "Summer Scandinavian travel is planned months in advance",
      icon: "ri-map-pin-2-line",
    },
    {
      name: "Caribbean",
      context: "Cruises and resort vacations for Owatonna families",
      urgency: "Cruise departure dates are fixed — passport must be ready well in advance",
      icon: "ri-map-pin-2-line",
    },
    {
      name: "Mexico",
      context: "Resort vacations and family travel for southern Minnesota families",
      urgency: "Resort packages are often booked 3–4 weeks out",
      icon: "ri-map-pin-2-line",
    },
    {
      name: "China",
      context: "Business travel for manufacturing equipment sales and installations",
      urgency: "Business assignments are often confirmed with short notice",
      icon: "ri-map-pin-2-line",
    },
    {
      name: "United Kingdom",
      context: "Business conferences and professional training for insurance and manufacturing professionals",
      urgency: "Conference schedules are fixed and require advance planning",
      icon: "ri-map-pin-2-line",
    },
  ],
  stats: [
    { stat: "33%", label: "of Owatonna expedited requests are business travel for manufacturing and insurance professionals" },
    { stat: "4–6 Weeks", label: "most common advance notice when Owatonna families discover passport issues before summer travel" },
    { stat: "May–Aug", label: "peak travel season for heritage trips and family vacations during summer break" },
    { stat: "5–7 Days", label: "typical expedited processing time for Owatonna clients choosing our recommended option" },
  ],
};

export default function OwatonnaMNPage() {
  return <CityPage data={data} />;
}